import request from './request'

// 获取体系课列表数据
export function getTxkList(page, pagesize, keyword, teacher) {
  const url = '/course/getsystemcourse'
  let params = {
    page: page,
    pagesize: pagesize,
    type: 1
  }
  if (typeof keyword !== 'undefined') {
    params.keywords = keyword
  }
  if (typeof teacher !== 'undefined') {
    params.teacher_id = teacher
  }
  return request.get(url, {
    params: params
  })
}

export function getTxDetail(cid) {
  const url = '/course_detail/syscoursedetail'
  return request.get(url, {
    params: {
      course_id: cid
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/tixike.js